import React from 'react';
import { Rocket, TrendingUp, Zap } from 'lucide-react';
import GameCatalog from '../components/GameCatalog';
import GameModal from '../components/GameModal';
import GameChoiceModal from '../components/GameChoiceModal';
import AuthModal from '../components/AuthModal';
import { useGameLauncher } from '../hooks/useGameLauncher';
import { useGameCatalog } from '../hooks/useGameCatalog';

const chips = [
  { id: 'all', name: 'Tümü', icon: Zap },
  { id: 'hot', name: 'Popüler', icon: TrendingUp },
  { id: 'new', name: 'Yeni', icon: Rocket },
];

const Crash = () => {
  const g = useGameLauncher();
  const catalog = useGameCatalog('crash');

  return (
    <div className="pusu-body-gradient">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-xl flex items-center justify-center" style={{ background: 'rgba(var(--pusu-gold-rgb),0.12)' }}>
            <Rocket size={22} className="text-[var(--pusu-gold)]" />
          </div>
          <div>
            <h1 className="text-2xl md:text-3xl font-black gold-text">Crash Oyunları</h1>
            <p className="text-sm text-gray-400">Çarpan yükselirken doğru anda çık, kazancı cebe at</p>
          </div>
        </div>

        <GameCatalog
          catalog={{ ...catalog, onPlay: g.play }}
          chips={chips}
          chipValue={catalog.flag}
          onChipChange={catalog.setFlag}
          searchPlaceholder="Oyun ara..."
          emptyText="Bu filtrelerle crash oyunu bulunamadı."
        />
      </div>

      <GameChoiceModal
        game={g.choice} user={g.user} balance={g.balance} bonusBalance={g.bonusBalance}
        demoAvailable={g.demoAvailable}
        onClose={g.closeChoice} onReal={g.startReal} onDemo={g.startDemo}
        onLogin={() => g.openAuth('login')} onRegister={() => g.openAuth('register')}
      />
      {g.activeGame && (
        <GameModal key={`${g.activeGame.id}-${g.mode}`} game={g.activeGame}
                   mode={g.mode} onClose={g.closeGame} />
      )}
      <AuthModal open={!!g.authTab} onClose={() => g.setAuthTab(null)} defaultTab={g.authTab || 'login'} />
    </div>
  );
};

export default Crash;
